// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__2BLMu","addWidgetButton":"Header_addWidgetButton__1-SM_","dashboardTabs":"Header_dashboardTabs__3rV96","active":"Header_active__JyZpY"};